var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSuccessfulApprovals(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2",
    transform: "translate(-1.5 -1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12129",
    "data-name": "Path 12129",
    d: "M0,0H50.372V40.919H0Z",
    transform: "translate(43.623 9.925) rotate(90)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12131",
    "data-name": "Path 12131",
    d: "M43.512,28.385V11.595L33.884,2H5V52.372H43.512V37.98",
    transform: "translate(4.925 0.704)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12133",
    "data-name": "Path 12133",
    d: "M26.628,11.628H17V2",
    transform: "translate(21.679 0.704)",
    fill: "#f8f6f9"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_212",
    "data-name": "Ellipse 212",
    cx: 13.239,
    cy: 13.239,
    r: 13.239,
    transform: "translate(33.819 19.459)",
    fill: "#d6fffa"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1658",
    "data-name": "Group 1658",
    transform: "translate(1.5 1.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_12135",
    "data-name": "Path 12135",
    d: "M29.329,12.781l-6.716,6.713L19.7,16.563a1.2,1.2,0,0,0-1.7,1.7l3.781,3.781a1.2,1.2,0,0,0,1.7,0l7.568-7.565a1.2,1.2,0,1,0-1.7-1.7Z",
    transform: "translate(21.043 13.785)",
    fill: "#5dadae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12136",
    "data-name": "Path 12136",
    d: "M61.5,32.7a14.414,14.414,0,0,0-12-14.184V12.3a1.2,1.2,0,0,0-.35-.85l-9.6-9.6a1.2,1.2,0,0,0-.85-.35H9.9A1.2,1.2,0,0,0,8.7,2.7v6h-6A1.2,1.2,0,0,0,1.5,9.9V60.3a1.2,1.2,0,0,0,1.2,1.2H43.5a1.2,1.2,0,0,0,1.2-1.2v-6h3.6a1.2,1.2,0,0,0,1.2-1.2V46.884A14.414,14.414,0,0,0,61.5,32.7ZM39.9,5.6l5.5,5.5H39.9Zm2.4,53.5H3.9v-48H8.7v42a1.2,1.2,0,0,0,1.2,1.2H42.3Zm4.8-7.2h-36V3.9H37.5v8.4a1.2,1.2,0,0,0,1.2,1.2h8.4v4.8a14.4,14.4,0,0,0,0,28.8Zm0-7.2a12,12,0,1,1,12-12,12,12,0,0,1-12,12Z",
    transform: "translate(-1.5 -1.5)",
    fill: "#5dadae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12137",
    "data-name": "Path 12137",
    d: "M14.724,13.845,11,17.585,9.554,16.141a1.2,1.2,0,0,0-1.7,1.7l2.294,2.291a1.2,1.2,0,0,0,1.7,0l4.585-4.573a1.2,1.2,0,1,0-1.7-1.7Z",
    transform: "translate(6.889 15.296)",
    fill: "#5dadae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12138",
    "data-name": "Path 12138",
    d: "M14.724,17.845,11,21.585,9.554,20.141a1.2,1.2,0,0,0-1.7,1.7l2.294,2.291a1.2,1.2,0,0,0,1.7,0l4.585-4.573a1.2,1.2,0,1,0-1.7-1.7Z",
    transform: "translate(6.889 20.892)",
    fill: "#5dadae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12139",
    "data-name": "Path 12139",
    d: "M8.7,6.907H23.146a1.2,1.2,0,0,0,0-2.407H8.7a1.2,1.2,0,0,0,0,2.407Z",
    transform: "translate(6.884 2.721)",
    fill: "#5dadae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12140",
    "data-name": "Path 12140",
    d: "M23.146,7.5H8.7a1.2,1.2,0,0,0,0,2.407H23.146a1.2,1.2,0,1,0,0-2.407Z",
    transform: "translate(6.884 6.898)",
    fill: "#5dadae"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_12141",
    "data-name": "Path 12141",
    d: "M15.925,10.5H8.7a1.2,1.2,0,0,0,0,2.407h7.221a1.2,1.2,0,0,0,0-2.407Z",
    transform: "translate(6.892 11.097)",
    fill: "#5dadae"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSuccessfulApprovals);
export default __webpack_public_path__ + "static/media/successful-approvals.557c306f25a4e5f888f818209190a9da.svg";
export { ForwardRef as ReactComponent };